
//VAS
const schoolUrl ='demo'

export const devEnv: any ={
    services:`services.${schoolUrl}.dev.nascorp.vn`,
    auth:`auth.${schoolUrl}.dev.nascorp.vn`,
    camp:`camp.${schoolUrl}.dev.nascorp.vn`,
    asa:`asa.${schoolUrl}.dev.nascorp.vn`,
    holiday:`holiday.${schoolUrl}.dev.nascorp.vn`,
    bus:`bus.${schoolUrl}.dev.nascorp.vn`,
    conference:`conference.${schoolUrl}.dev.nascorp.vn`,
    reen: `reen.${schoolUrl}.dev.nascorp.vn`,
    event:`event.${schoolUrl}.dev.nascorp.vn`
};

export const testEnv: any ={
    services:`services.${schoolUrl}.test.nascorp.vn`,
    auth:`auth.${schoolUrl}.test.nascorp.vn`,
    camp:`camp.${schoolUrl}.test.nascorp.vn`,
    asa:`asa.${schoolUrl}.test.nascorp.vn`,
    holiday:`holiday.${schoolUrl}.test.nascorp.vn`,
    bus:`bus.${schoolUrl}.test.nascorp.vn`,
    conference:`conference.${schoolUrl}.test.nascorp.vn`,
    reen: `reen.${schoolUrl}.test.nascorp.vn`,
    event:`event.${schoolUrl}.test.nascorp.vn`
};

export const procEnv: any = {
    services:`ppservices.${schoolUrl}.edu.vn`,
    auth:`ppauth.${schoolUrl}.edu.vn`,
    camp:`ppcamp.${schoolUrl}.edu.vn`,
    asa:`ppasa.${schoolUrl}.edu.vn`,
    holiday:`ppholiday.${schoolUrl}.edu.vn`,
    bus:`ppbus.${schoolUrl}.edu.vn`,
    conference:`ppconference.${schoolUrl}.edu.vn`,
    reen: `ppreen.${schoolUrl}.edu.vn`,
    event:`ppevent.${schoolUrl}.edu.vn`
};

export const stagingEnv: any ={ 
    auth:`ppuauth.${schoolUrl}.edu.vn`,
    services:`ppuservices.${schoolUrl}.edu.vn`,
    asa:`ppuasa.${schoolUrl}.edu.vn`,
    holiday:`ppuholiday.${schoolUrl}.edu.vn`,
    bus:`ppubus.${schoolUrl}.edu.vn`,
    camp:`ppucamp.${schoolUrl}.edu.vn`,
    reen:`ppureen.${schoolUrl}.edu.vn`,
    conference:`ppuconference.${schoolUrl}.edu.vn`,
    event:`ppuevent.${schoolUrl}.edu.vn`,
};

export const localEnv: any = {
    services:`services.local.${schoolUrl}.dev.nascorp.vn`,
    auth:`auth.local.${schoolUrl}.dev.nascorp.vn`,
    camp:`camp.local.${schoolUrl}.dev.nascorp.vn`,
    asa:`asa.local.${schoolUrl}.dev.nascorp.vn`,
    holiday:`holiday.local.${schoolUrl}.dev.nascorp.vn`,
    bus:`bus.local.${schoolUrl}.dev.nascorp.vn`,
    conference:`conference.local.${schoolUrl}.dev.nascorp.vn`,
    reen:`reen.local.${schoolUrl}.dev.nascorp.vn`,
    event:`event.local.${schoolUrl}.dev.nascorp.vn`,
};

export const demoEnv: any = {
    services:`services.demo.nascorp.vn`,
    auth:`auth.demo.nascorp.vn`,
    camp:`camp.demo.nascorp.vn`,
    asa:`asa.demo.nascorp.vn`,
    holiday:`holiday.demo.nascorp.vn`,
    bus:`bus.demo.nascorp.vn`,
    conference:`conference.demo.nascorp.vn`,
    reen:`reen.demo.nascorp.vn`,
    event:`event.demo.nascorp.vn`,
};

export const bisHanoiEnv: any = {
    services:`services.bishanoi.nascorp.vn`,
    auth:`auth.bishanoi.nascorp.vn`,
    camp:`camp.bishanoi.nascorp.vn`,
    asa:`asa.bishanoi.nascorp.vn`,
    holiday:`holiday.bishanoi.nascorp.vn`,
    bus:`bus.bishanoi.nascorp.vn`,
    conference:`conference.bishanoi.nascorp.vn`,
    reen:`reen.bishanoi.nascorp.vn`,
    event:`event.bishanoi.nascorp.vn`,
};
export const bisHanoiDevEnv: any = {
    services:`services.bishanoi.dev.nascorp.vn`,
    auth:`auth.bishanoi.dev.nascorp.vn`,
    camp:`camp.bishanoi.dev.nascorp.vn`,
    asa:`asa.bishanoi.dev.nascorp.vn`,
    holiday:`holiday.bishanoi.dev.nascorp.vn`,
    bus:`bus.bishanoi.dev.nascorp.vn`,
    conference:`conference.bishanoi.dev.nascorp.vn`,
    reen:`reen.bishanoi.dev.nascorp.vn`,
    event:`event.bishanoi.dev.nascorp.vn`,
};
export const bisHanoiStagingEnv: any = {
    services:`services.bishanoistaging.nascorp.vn`,
    auth:`auth.bishanoistaging.nascorp.vn`,
    camp:`camp.bishanoistaging.nascorp.vn`,
    asa:`asa.bishanoistaging.nascorp.vn`,
    holiday:`holiday.bishanoistaging.nascorp.vn`,
    bus:`bus.bishanoistaging.nascorp.vn`,
    conference:`conference.bishanoistaging.nascorp.vn`,
    reen:`reen.bishanoistaging.nascorp.vn`,
    event:`event.bishanoistaging.nascorp.vn`,
};
export const ishcmcEnv: any = {
    services:`services.ishcmc.nascorp.vn`,
    auth:`auth.ishcmc.nascorp.vn`,
    camp:`camp.ishcmc.nascorp.vn`,
    asa:`asa.ishcmc.nascorp.vn`,
    holiday:`holiday.ishcmc.nascorp.vn`,
    bus:`bus.ishcmc.nascorp.vn`,
    conference:`conference.ishcmc.nascorp.vn`,
    reen:`reen.ishcmc.nascorp.vn`,
    event:`event.ishcmc.nascorp.vn`,
};
export const aavnIshcmcEnv: any = {
    services:`services.aavn.ishcmc.nascorp.vn`,
    auth:`auth.aavn.ishcmc.nascorp.vn`,
    camp:`camp.aavn.ishcmc.nascorp.vn`,
    asa:`asa.aavn.ishcmc.nascorp.vn`,
    holiday:`holiday.aavn.ishcmc.nascorp.vn`,
    bus:`bus.aavn.ishcmc.nascorp.vn`,
    conference:`conference.aavn.ishcmc.nascorp.vn`,
    reen:`reen.aavn.ishcmc.nascorp.vn`,
    event:`event.aavn.ishcmc.nascorp.vn`,
};
export const primaryIshcmcEnv: any = {
    services:`services.primary.ishcmc.nascorp.vn`,
    auth:`auth.primary.ishcmc.nascorp.vn`,
    camp:`camp.primary.ishcmc.nascorp.vn`,
    asa:`asa.primary.ishcmc.nascorp.vn`,
    holiday:`holiday.primary.ishcmc.nascorp.vn`,
    bus:`bus.primary.ishcmc.nascorp.vn`,
    conference:`conference.primary.ishcmc.nascorp.vn`,
    reen:`reen.primary.ishcmc.nascorp.vn`,
    event:`event.primary.ishcmc.nascorp.vn`,
};
export const secondaryIshcmcEnv: any = {
    services:`services.secondary.ishcmc.nascorp.vn`,
    auth:`auth.secondary.ishcmc.nascorp.vn`,
    camp:`camp.secondary.ishcmc.nascorp.vn`,
    asa:`asa.secondary.ishcmc.nascorp.vn`,
    holiday:`holiday.secondary.ishcmc.nascorp.vn`,
    bus:`bus.secondary.ishcmc.nascorp.vn`,
    conference:`conference.secondary.ishcmc.nascorp.vn`,
    reen:`reen.secondary.ishcmc.nascorp.vn`,
    event:`event.secondary.ishcmc.nascorp.vn`,
};
export const isspEnv: any = {
    services:`services.issp.nascorp.vn`,
    auth:`auth.issp.nascorp.vn`,
    camp:`camp.issp.nascorp.vn`,
    asa:`asa.issp.nascorp.vn`,
    holiday:`holiday.issp.nascorp.vn`,
    bus:`bus.issp.nascorp.vn`,
    conference:`conference.issp.nascorp.vn`,
    reen:`reen.issp.nascorp.vn`,
    event:`event.issp.nascorp.vn`,
};
export const demoHelenEnv: any = {
    services:`services.demo.helen.edu.vn`,
    auth:`auth.demo.helen.edu.vn`,
    camp:`camp.demo.helen.edu.vn`,
    asa:`asa.demo.helen.edu.vn`,
    holiday:`holiday.demo.helen.edu.vn`,
    bus:`bus.demo.helen.edu.vn`,
    conference:`conference.demo.helen.edu.vn`,
    reen:`reen.demo.helen.edu.vn`,
    event:`event.demo.helen.edu.vn`,
}

export const demoJeduEnv: any = {
    services:`services.demo.jedu.edu.vn`,
    auth:`auth.demo.jedu.edu.vn`,
    camp:`camp.demo.jedu.edu.vn`,
    asa:`asa.demo.jedu.edu.vn`,
    holiday:`holiday.demo.jedu.edu.vn`,
    bus:`bus.demo.jedu.edu.vn`,
    conference:`conference.demo.jedu.edu.vn`,
    reen:`reen.demo.jedu.edu.vn`,
    event:`event.demo.jedu.edu.vn`,
}


// WEBPACK FOOTER //
// ./src/common/config/config.ts